export { default } from './TableContainer';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TableContainer/index.js
// module id = 854
// module chunks = 2